<template>
  <div>
    <q-dialog v-model="show" @input="(val) => $emit('input', val)">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium search-modal">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{ label }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container style="padding-top: 60px;" class="scroll search-page-container">
          <div class="search-form-wrapper">
            <jt-dynamic-form
              ref="dynamicForm"
              :interface="'invoiceSettlement.pesquisar'"
              :inputs="forms.inputs"
              :relacionamentos="forms.relacionamentos"
              :model="forms.dadosForm"
              form-class="form dynamic"
              @action-click="actionClick"
              @search-found="onSearchFound"
            />
            <div
              v-if="forms && forms.buttons && forms.buttons.length"
              class="row full-width q-col-gutter-lg justify-center q-py-md search-actions"
            >
              <div class="col-lg-3 col-md-4 col-sm-5 col-12">
                <q-btn class="full-width" color="grey-7" @click="limparForm">
                  <translate>CLEAN</translate>
                </q-btn>
              </div>
              <div
                v-for="(button, i) in forms.buttons"
                :key="i"
                :class="`col-lg-3 col-md-4 col-sm-5 col-12 button-${button.name}`"
              >
                <q-btn
                  :class="`full-width button-btn-${button.name}`"
                  :color="'green'"
                  @click="actionButton(button)"
                >
                  <q-icon
                    v-if="button.icon"
                    :name="button.icon"
                    size="18px"
                    class="position-icon-filter"
                  />
                  {{ button.label }}
                </q-btn>
              </div>
            </div>
          </div>
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import { repository } from 'jtech'

const { modal } = JtCrud

@Component({
  mixins: [modal],
  name: 'ServiceRequestInvoiceSettlementSearch',
  components: { },
  props: {
    form: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  }
})
class ServiceRequestInvoiceSettlementSearch extends Vue {
  forms = {}
  async mounted () {
    const form = await repository.resolve('invoiceSettlement.pesquisarInServiceRequest', {})
    this.forms = form[0]
  }

  actionButton (button) {
    this.$emit('search-click', this.forms.dadosForm)
  }

  limparForm () {
    this.$refs.dynamicForm.resetForm()
  }
}
export default ServiceRequestInvoiceSettlementSearch
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.search-modal{
  width: 72vw
  max-width: 980px
  min-width: 0
  height: 80vh
  min-height: 520px
}

.search-page-container{
  padding-left: 24px
  padding-right: 24px
  max-height: calc(80vh - 50px)
}

.search-form-wrapper{
  width: 100%
  max-width: 820px
  margin: 0 auto
  padding-top: 16px
}

.search-actions{
  margin-top: 8px
}

.container-page-person {
    height: calc(80vh);
}

.container-person {
  .dynamic-form #scroll-area {
    height: calc(40vh - 12px) !important;
  }

 .dynamic-compositions{
    .dynamic-form #scroll-area {
    height: calc(50vh - 12px)!important;
  }
 }
}

@media only screen and (max-height: 880px) {
  .container-person {
    .dynamic-form #scroll-area {
      height: calc(42vh - 12px) !important;
    }

  .addressPersonForms{
    .dynamic-form #scroll-area {
      height: calc(66vh - 12px) !important;
      }
    }
  }
}

@media only screen and (max-height: 800px) {
  .container-person {
    .dynamic-form #scroll-area {
      height: calc(44vh - 12px) !important;
    }
  }
}

@media only screen and (max-width: 1024px) {
  .search-modal{
    width: 88vw
    max-width: none
    min-height: 480px
  }

  .search-page-container{
    padding-left: 16px
    padding-right: 16px
  }

  .search-form-wrapper{
    padding-top: 12px
  }
}
</style>
